import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Table from "../../core/common/dataTable/index";
import PerformanceIndicatorModal from "../../core/modals/performanceIndicatorModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchAllRoleindicator } from "../../core/data/redux/performance/roleindicator/roleindicatorAction";
import { fetchAllIndicatorGroup } from "../../core/data/redux/performance/indicatorgroup/indicatorgroupAction";
import { fetchAllIndicator } from "../../core/data/redux/performance/indicator/indicatorAction";
import { fetchAllDesignations } from "../../core/data/redux/designation/designationAction";
import Select from "react-select";
import {
  deleteRoleindicator,
  updateRoleindicator,
} from "../../core/data/redux/performance/roleindicator/roleindicatorAction";
import { fetchAllKRA } from "../../core/data/redux/performance/KRA/kraAction";

import DeleteModal1 from "../../core/modals/deleteModal1";
import { Drawer, message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { formatDate } from "../../core/utils/configFormatters";
import { useAppConfig } from "../../customhooks/useAppConfig";
import { decryptData } from "../../core/utils/encryptUtils";
const PerformanceIndicator = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { indicatorgroup } = useSelector(
    (state: any) => state.performance.indicatorgroup
  );
  const { indicator } = useSelector(
    (state: any) => state.performance.indicator
  );
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const { kra } = useSelector((state: any) => state.performance.kra);
  const { user } = useSelector((state: any) => state.auth);
  const { designations } = useSelector((state: any) => state.designation);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const { roleindicator, loadingStates } = useSelector((state: any) => state.performance.roleindicator);
  const isLoading = isEditing ? loadingStates.update : false;
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const Roleindicator = selectedRowData?.Id;
  const [tableKey, setTableKey] = useState(0);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [iseditDrawerVisible, setIseditDrawerVisible] = useState(false);
  const [errors, setErrors] = useState<any>({});
  useEffect(() => {
    dispatch(fetchAllRoleindicator());
    dispatch(fetchAllIndicatorGroup());
    dispatch(fetchAllIndicator());
    dispatch(fetchAllDesignations());
    dispatch(fetchAllKRA());
  }, []);

  const status = [
    { value: "Select", label: "Select" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const formattedDegination = designations.map((emp: any) => ({
    value: emp.DesignationId,
    label: emp.DesignationName,
  }));

  const formattedIndicatorGroup = indicatorgroup.map((group: any) => ({
    value: group.Id,
    label: group.Name,
  }));
  const formattedRating = indicatorgroup.map((group: any) => ({
    value: group.Id,
    label: group.Name,
  }));

  const formattedIndicator = indicator.map((emp: any) => ({
    value: emp.Id,
    label: emp.Name,
    fullData: emp,
  }));

  const formattedKRA = kra.map((emp: any) => ({
    value: emp.id,
    label: emp.Name,
  }));

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const [formData, setFormData] = useState<any>({
    role_name: "",
    selectedRole: formattedDegination[0] || {
      value: "Select",
      label: "Select",
    },
    groups: [],
    status: status[1],
    modifiedBy: user.UserId,
  });

  const StarRating = ({
    rating,
    onRate,
  }: {
    rating: number;
    onRate: (rating: number) => void;
  }) => {
    const handleClick = (star: number, isHalf: boolean) => {
      const newRating = isHalf ? star - 0.5 : star;
      onRate(newRating);
    };

    return (
      <div style={{ display: "flex", gap: "4px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <div
            key={star}
            style={{
              position: "relative",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                position: "absolute",
                width: "50%",
                overflow: "hidden",
                color: rating >= star - 0.5 ? "gold" : "gray",
              }}
              onClick={() => handleClick(star, true)}
            >
              ★
            </span>

            <span
              style={{
                color: rating >= star ? "gold" : "gray",
              }}
              onClick={() => handleClick(star, false)}
            >
              ★
            </span>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (selectedRowData) {
      setFormData((prevFormData: any) => {
        const updatedData = {
          role_name: selectedRowData.Name || "",
          selectedRole: formattedDegination.find(
            (role: any) => role.value === selectedRowData.DesignationId
          ) || { value: "Select", label: "Select" },
          groups:
            selectedRowData.role_groups?.map((group: any, gIndex: number) => ({
              id: group.id || gIndex + 1,
              serial_no: group.serial_no,
              weightage: group.weightage,
              selectedGroup:
                formattedIndicatorGroup.find(
                  (opt: any) => opt.value === group.selectedGroup.value
                ) || null,
              indicators: group.indicators?.map(
                (indicator: any, iIndex: number) => {
                  return {
                    id: indicator.id || `${gIndex + 1}-${iIndex + 1}`,
                    kra:
                      formattedKRA.find(
                        (opt: any) => opt.value === indicator.kra.id
                      ) || null,
                    indicator:
                      formattedIndicator.find(
                        (opt: any) =>
                          opt.value === indicator.indicator?.id ||
                          opt.value === indicator.indicator
                      ) || null,

                    weightage: indicator.weightage,
                    rating: indicator.rating,
                  };
                }
              ),
            })) || [],
          status:
            status.find((opt: any) => opt.value === selectedRowData.Status) ||
            status[0],
        };
        return JSON.stringify(prevFormData) === JSON.stringify(updatedData)
          ? prevFormData
          : updatedData;
      });
    }
  }, [selectedRowData]);

  const handleRoleChange = (selectedOption: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      selectedRole: selectedOption.value,
    }));
  };

  const handleStatusChange = (selectedOption: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      status: selectedOption,
    }));
  };

  const handleWeightageChange = (e: any, groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId ? { ...group, weightage: e.target.value } : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleRemoveGroup = () => {
    setFormData((prevState: any) => {
      if (prevState.groups.length === 0) return prevState;

      return {
        ...prevState,
        groups: prevState.groups.slice(0, -1),
      };
    });
  };

  const handleAddGroup = () => {
    setFormData((prevState: any) => ({
      ...prevState,
      groups: [
        ...prevState.groups,
        {
          id: Date.now(),
          serial_no: prevState.groups.length + 1,
          weightage: "",
          selectedGroup: null,
          indicators: [],
        },
      ],
    }));
  };

  const handleGroupChange = (selectedOption: any, groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId
          ? { ...group, selectedGroup: selectedOption }
          : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleAddIndicatorRow = (groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId
          ? {
            ...group,
            indicators: [
              ...group.indicators,
              {
                id: Date.now(),
                indicator: "",
                rating: "",
                weightage: "",
              },
            ],
          }
          : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleInputChange = (
    e: any,
    groupId: number,
    index: number,
    isSelect = false,
    fieldName = ""
  ) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) => {
        if (group.id === groupId) {
          const updatedIndicators = group.indicators.map((ind: any) => ({
            ...ind,
          }));

          if (isSelect) {
            updatedIndicators[index] = {
              ...updatedIndicators[index],
              [fieldName]: e.value,
            };
          } else {
            const { name, value } = e.target;
            updatedIndicators[index] = {
              ...updatedIndicators[index],
              [name]: value,
            };
          }

          return { ...group, indicators: updatedIndicators };
        }
        return group;
      });

      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleRemoveIndicatorRow = (groupId: number, indicatorId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) => {
        if (group.id === groupId) {
          return {
            ...group,
            indicators: group.indicators.filter(
              (ind: any) => ind.id !== indicatorId
            ),
          };
        }
        return group;
      });
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
    const roleGroups = record.role_groups || [];
    const mappedGroups = roleGroups.map((group: any, index: number) => ({
      serial_no: group.serial_no || index + 1,
      selectedGroup: group.selectedGroup || {
        label: "Select",
        value: "Select",
      },
      indicators: group.indicators || [],
      weightage: group.weightage || 0,
    }));
    setFormData({
      role_name: record.Name,
      selectedRole: record.DesignationId || {
        value: "Select",
        label: "Select",
      },
      groups: mappedGroups,
      status: record.Status,
    });
  };

  const handleRatingChange = (
    newRating: number,
    groupId: number,
    index: number
  ) => {
    setFormData((prev: any) => {
      const updatedGroups = prev.groups.map((group: any) => {
        if (group.id === groupId) {
          const updatedIndicators = [...group.indicators];

          if (updatedIndicators[index]) {
            updatedIndicators[index] = {
              ...updatedIndicators[index],
              rating: newRating,
            };
          }

          return { ...group, indicators: updatedIndicators };
        }
        return group;
      });

      return { ...prev, groups: updatedGroups };
    });
  };

  const handleDelete = (Roleindicator: any) => {
    const TerminationId = Roleindicator;
    dispatch(deleteRoleindicator(Roleindicator))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          dispatch(fetchAllRoleindicator());
          message.success(resp.payload.message);
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      role_name: "",
      selectedRole: "",
      groups: "",
      status: "",
    };

    if (!formData.role_name.trim()) {
      formIsValid = false;
      newErrors.role_name = "Role name is required.";
    }

    if (!formData.selectedRole || formData.selectedRole.value === "Select") {
      formIsValid = false;
      newErrors.selectedRole = "Role selection is required.";
    }

    if (!formData.groups || formData.groups.length === 0) {
      formIsValid = false;
      newErrors.groups = "At least one group is required.";
    }

    if (!formData.status || formData.status.value === "Select") {
      formIsValid = false;
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    const cleanedFormData = JSON.parse(JSON.stringify(formData));

    cleanedFormData.groups.forEach((group: any) => {
      group.indicators.forEach((indicator: any) => {
        if (indicator.indicator && indicator.indicator.fullData) {
          delete indicator.indicator.fullData;
        }
      });
    });

    cleanedFormData.designation_id =
      cleanedFormData.selectedRole?.value || null;
    cleanedFormData.status = cleanedFormData.status?.value || null;

    dispatch(updateRoleindicator({ Roleindicator, data: cleanedFormData }))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAllRoleindicator());
        } else {
          message.warning(res.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const routes = all_routes;
  const data = roleindicator;

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "created_at", "created_at", selectedSort);
  }, [dispatch, selectedStatus, roleindicator, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, roleindicator, selectedStatus]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      render: (text: string) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Designation.length - b.Designation.length,
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.CreatedDate.length - b.CreatedDate.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span className="badge badge-success d-inline-flex align-items-center badge-xs">
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex gap-2">
          {/* Edit button - controlled by canEdit */}
          <button
            onClick={() => {
              if (!canEdit) return;
              setIsEditing(true);
              handleEditPolicy(record);
              setIseditDrawerVisible(true);
            }}
            disabled={!canEdit}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit"
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete button - controlled by canDelete */}
          <button
            onClick={() => {
              if (!canDelete) return;
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            disabled={!canDelete}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: canDelete ? "pointer" : "not-allowed",
              opacity: canDelete ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete"
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Role Indicator</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Role Indicator
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      setIsEditing(false);
                      setIsDrawerVisible(true);
                    }}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Role Indicator
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Role Indicator List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <PerformanceIndicatorModal
        open={isDrawerVisible}
        onClose={() => {
          setIsEditing(false);
          setIsDrawerVisible(false);
        }}
      />

      <Drawer
        title="Edit Role Indicator"
        placement="right"
        onClose={() => setIseditDrawerVisible(false)}
        open={iseditDrawerVisible}
        width={600}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="role_name"
                    value={formData.role_name}
                    onChange={(e) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        role_name: e.target.value,
                      }))
                    }
                  />
                  {errors.role_name && (
                    <div style={{ color: "red" }}>{errors.role_name}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Role <span className="text-danger"> *</span>
                  </label>
                  <Select
                    options={formattedDegination}
                    value={formattedDegination.find(
                      (opt: any) => opt.value === formData.selectedRole?.value
                    )}
                    onChange={(selectedOption: any) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        selectedRole: selectedOption,
                      }))
                    }
                  />
                  {errors.selectedRole && (
                    <div style={{ color: "red" }}>{errors.selectedRole}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3 d-flex justify-content-between align-items-center">
                  <label className="fw-medium">
                    Add Group <span className="text-danger"> *</span>
                  </label>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={handleAddGroup}
                  >
                    +
                  </button>
                </div>
                {errors.groups && (
                  <div className="text-danger mb-2">{errors.groups}</div>
                )}
              </div>

              {/* Groups Section */}
              {formData.groups.map((group: any, groupIndex: number) => (
                <div key={group.id} className="col-md-12">
                  <div className="p-3 mb-4 border rounded bg-light">
                    <h5 className="fw-bold text-primary">
                      Indicator Group {groupIndex + 1}:{" "}
                      {group.selectedGroup ? group.selectedGroup.label : ""}
                    </h5>
                    <div className="d-flex gap-3 align-items-center">
                      <Select
                        options={formattedIndicatorGroup}
                        value={formattedIndicatorGroup.find(
                          (opt: any) => opt.value === group.selectedGroup?.value
                        )}
                        onChange={(e: any) =>
                          handleGroupChange(e, group.serial_no)
                        }
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="weightage"
                        value={group.weightage}
                        onChange={(e) =>
                          handleWeightageChange(e, group.serial_no)
                        }
                      />
                    </div>

                    {group.selectedGroup && (
                      <div
                        className="table-responsive"
                        style={{
                          overflowX: "auto",
                          overflowY: "hidden",
                          position: "relative",
                          zIndex: 1,
                          maxWidth: "100%",
                        }}
                      >
                        <table
                          className="table table-bordered mt-3"
                          style={{ minWidth: "1000px" }}
                        >
                          <thead>
                            <tr>
                              <th>S. No</th>
                              <th>
                                KRA <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Indicator{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Weightage{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Expected-Rating{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {group.indicators.length === 0 &&
                              handleAddIndicatorRow(group.id)}
                            {group.indicators.map(
                              (indicator: any, index: number) => (
                                <tr key={indicator.id}>
                                  <td>{indicator.serial_no || index + 1}</td>
                                  <td>
                                    <Select
                                      options={formattedKRA}
                                      value={formattedKRA.find(
                                        (opt: any) =>
                                          opt.value === indicator.kra?.value
                                      )}
                                      onChange={(selectedOption: any) =>
                                        handleInputChange(
                                          selectedOption,
                                          group.serial_no,
                                          index,
                                          true,
                                          "kra"
                                        )
                                      }
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base: any) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        menu: (base: any) => ({
                                          ...base,
                                          zIndex: 9999,
                                          position: "absolute",
                                          right: 0,
                                          left: "auto",
                                        }),
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <Select
                                      options={formattedIndicator}
                                      name="indicator"
                                      value={formattedIndicator.find(
                                        (opt: any) =>
                                          opt.value === indicator?.indicator?.id
                                      )}
                                      onChange={(e: any) =>
                                        handleInputChange(
                                          e,
                                          group.id,
                                          index,
                                          true,
                                          "indicator"
                                        )
                                      }
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base: any) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="weightage"
                                      value={indicator.weightage}
                                      onChange={(e) =>
                                        handleInputChange(e, group.id, index)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <td>
                                      <StarRating
                                        rating={indicator.rating}
                                        onRate={(newRating) =>
                                          handleRatingChange(
                                            newRating,
                                            group.id,
                                            index
                                          )
                                        }
                                      />
                                    </td>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm me-2"
                                      onClick={() =>
                                        handleRemoveIndicatorRow(
                                          group.id,
                                          indicator.id
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() =>
                                        handleAddIndicatorRow(group.id)
                                      }
                                    >
                                      +
                                    </button>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                  <div className="modal-body">
                    <div className=" d-flex justify-content-end gap-3">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleAddGroup}
                      >
                        +
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={handleRemoveGroup}
                      >
                        -
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Status <span className="text-danger"> *</span></label>
                <Select
                  options={status}
                  value={status.find(
                    (opt) => opt.value === formData.status?.value
                  )}
                  onChange={handleStatusChange}
                />
              </div>
              {errors.status && (
                <div className="text-danger mt-1">{errors.status}</div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIseditDrawerVisible(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading && (<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />)}
              {isEditing ? "Update Indicator" : ""}
              Update Indicator
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDelete(selectedRowData?.Id)
        }
      />

      <style>
        {`
      .table-responsive::-webkit-scrollbar {
        height: 12px;
        width: 8px;
      }

      .table-responsive::-webkit-scrollbar-track {
        background: #e0e0e0;
      }

      .table-responsive::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 6px;
      }

      .table-responsive::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    `}
      </style>
    </>
  );
};

export default PerformanceIndicator;
